/** @format */
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ContentfulQueryId } from '@toucan/common/contentful';

import { MarketContext } from '@toucan/client/global/market';

import { type ContentfulQueryVariables } from './config/types';
import { getContentfulData } from './requests';

export { type ContentfulQueryVariables };

export const useContentful = <
    R,
    V extends ContentfulQueryVariables = undefined,
    SelectReturnType = undefined,
>(
    queryId: ContentfulQueryId,
    variables?: V,
    options: UseQueryOptions<R, unknown, SelectReturnType> = {}
) => {
    const { activeMarket } = useContext(MarketContext);
    const locale = activeMarket.iso;

    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Legacy code: do not use as an example.
    return useQuery({
        queryKey: variables ? [queryId, variables] : [queryId],
        queryFn: () => getContentfulData<R>(queryId, locale, variables),
        ...options,
    });
};
